import { Component, Input, OnInit } from '@angular/core';
import { SyncDataResponse } from 'src/app/core/state/_models/form.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionService } from 'src/app/core/services/action.service';
import { OpTypes } from 'src/app/core/state/_models/general.model';
import { Reset } from 'src/app/core/state/_actions/form.actions';
import { getFormOperations } from 'src/app/core/state/_selectors/form.selector';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  @Input('response') response: SyncDataResponse | null = null;
  @Input('isBulkupdate') isBulkupdate: boolean = true;

  constructor(private modal: NgbModal, private action: ActionService) {}

  ngOnInit(): void {}

  close(data = false) {
    this.modal.dismissAll(data);
    this.action.dispatch(OpTypes.DELETE, new Reset(), getFormOperations);
  }
}
